/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyList } from '../../models/api-key-list';

export interface GetApiKeys$Params {
  'Active-Tenant-Identifier': string;
}

export function getApiKeys(http: HttpClient, rootUrl: string, params: GetApiKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyList>> {
  const rb = new RequestBuilder(rootUrl, getApiKeys.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeyList>;
    })
  );
}

getApiKeys.PATH = '/api-keys';
